import { createSelector } from "reselect";
import { LoadingState, LoadingStatus, TLoadingProp } from "../../features/loading/types";
import { LOADING_STATUSES } from "../../features/loading/";

const inProgress = (status: LoadingStatus): boolean => status === LOADING_STATUSES.loading;

const isLoaded = (status: LoadingStatus): boolean => status === LOADING_STATUSES.loaded;

const isError = (status: LoadingStatus): boolean => status === LOADING_STATUSES.failed;

const mapLoadingStateToProps = ({ status }: LoadingState): TLoadingProp => ({
  inProgress: inProgress(status),
  isLoaded: isLoaded(status),
  isError: isError(status),
});

export const loadingSelector = (loadingStateSelector: any) =>
  createSelector([loadingStateSelector], (loadingState: any) =>
    mapLoadingStateToProps(loadingState)
  );
